import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const VideoList = props => {
    const { category } = useParams();
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const getVideos = async () => {
            const response = await axios.get(`https://api.themoviedb.org/3/${category}/${props.id}/videos?api_key=088f4df643022cbbe2a297babd84490c`);
            setVideos(response.data.results.slice(0, 5));
        }
        getVideos();
    }, [category, props.id]);
    return (
        <>
            {
                videos.map((item, index) => (
                    <Video key={index} item={item} />
                ))
            }
        </>
    )
}

export const Video = props => {
    const item = props.item;
    const iframeRef = useRef(null);

    useEffect(() => {
        const height = iframeRef.current.offsetWidth * 9 / 16 + 'px';
        iframeRef.current.setAttribute('height', height);
    }, []);

    return (
        <div className="video">
            <div className="video__title">
                <h2>{item.name}</h2>
            </div>
            <iframe
                src={`https://www.youtube.com/embed/${item.key}`} frameborder="0"
                ref={iframeRef}
                width='100%'
                title={item.name}
            ></iframe>
        </div>
    )
}

export default VideoList